exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-select[data-v-c36a090c] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.calendar-buttons-group[data-v-c36a090c] {\n  margin-top: 6px;\n}\n.calendar-button[data-v-c36a090c] {\n  margin: 10px 10px 10px 10px;\n}\n", ""]);

// exports
